export default __webpack_public_path__ + "static/media/details.7d40ae82.PNG";